import { Box } from '@mui/material';
import SpaceBox from './SpaceBox';
import React from 'react';

export default function DescriptionSection(props: {
  subTitle: string;
  mainTitle: string;
  description: string;
}) {
  const { subTitle, mainTitle, description } = props;
  return (
    <>
      <Box
        sx={{
          textAlign: 'center',
          color: 'primary.main',
          fontWeight: 800,
          fontSize: { xs: '12px', sm: '16px' },
          marginBottom: { xs: '1px' },
        }}
      >
        {subTitle}
      </Box>
      <SpaceBox height={14} smHeight={22} />
      <Box
        sx={{
          textAlign: 'center',
          fontWeight: 800,
          color: 'text.primary',
          fontSize: { xs: '25px', sm: '38px' },
          lineHeight: { xs: '125%' },
        }}
        dangerouslySetInnerHTML={{ __html: mainTitle }}
      />
      <SpaceBox height={10} smHeight={19} />
      <Box
        sx={{
          textAlign: 'center',
          fontWeight: 400,
          color: 'text.secondary',
          opacity: 0.8,
          lineHeight: { xs: '21px', sm: '26px' },
          fontSize: { xs: '14px', sm: '16px' },
        }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </>
  );
}
